/*import { Box, Grid, Flex, Image } from '@chakra-ui/react';
import React, { useRef } from 'react';
import { Canvas, useFrame } from '@react-three/fiber';
import * as THREE from 'three';
import marsTexture from '../../../assets/mars-1.jpg'; 

const StarsBackground = ({roadPositionX, rotateRoadScale}) => {
  return (
    <Box className="mars-scene" opacity="0.6">
      <Image 
        src={marsTexture} 
        objectFit="cover"
        transition="0.3s all"
        objectPosition="right"
        transform={`
          scale(${rotateRoadScale === 8 ? 1.05 : 1 }) 
          translateX(${roadPositionX}px)`}
        h="100%"  />
    </Box>
  );
};

export default StarsBackground;*/

import { Box } from '@chakra-ui/react';
import React, { useRef, useMemo } from 'react';
import { Canvas, useFrame } from '@react-three/fiber';
import * as THREE from 'three';
import cylinderTexture from '../../../assets/texture/1.jpg'; 

const RotatingCylinder = () => {
  const cylinderRef = useRef();
  const texture = useMemo(() => new THREE.TextureLoader().load(cylinderTexture), []);

  useFrame((state, delta) => {
    if (cylinderRef.current) {
      cylinderRef.current.rotation.y += 0.1 * delta; 
    }
  });

  return (
    <mesh ref={cylinderRef} position={[0, 0, 0]}>
      <sphereGeometry args={[16, 64, 64]} /> 
      <meshStandardMaterial map={texture} />
    </mesh>
  );
};

const StarsBackground = ({roadPositionX, rotateRoadScale}) => {
  const canvasElement = useMemo(() => (
    <Canvas camera={{ position: [0, 0, 30], fov: 75 }}>
      <ambientLight intensity={0.5} />
      <directionalLight position={[5, 5, 5]} intensity={1} />
      <RotatingCylinder />
    </Canvas>
  ), []); 

  return (
    <Box 
      className='cylinder-scene' 
      overflow='visible' 
      transition="0.3s all"
        objectPosition="right"
        transform={`
          rotate(90deg)
          scale(${rotateRoadScale === 8 ? 1.81 : 1.7 }) 
          translateY(${roadPositionX}px)`}

      mt='-50%'>
      {canvasElement}
    </Box>
  );
};

export default StarsBackground;
